export const checkinModalConversation = {
  guestFallback: "Invitado",
  conversationLabel: "Conversación :",
  replyOnWhatsAppLabel: "Responder en WhatsApp:",
  replyOnWhatsAppTooltip: "Responder en WhatsApp",
};
